let stackEl: HTMLElement | null = null;

export function initMobileStack(): HTMLElement {
  if (stackEl) return stackEl;
  const el = document.createElement('div');
  el.id = 'single-mobile-stack';
  document.body.appendChild(el);
  stackEl = el;
  return el;
}

export function getMobileStack(): HTMLElement | null {
  return stackEl;
}